"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FollowRequestDTOSchema = exports.FollowDTO = exports.FollowSchema = exports.FollowBaseSchema = void 0;
var zod_1 = require("zod");
var ObjectId_1 = require("./lib/ObjectId");
var CommonMongoModelFields_1 = require("./lib/CommonMongoModelFields");
var User_1 = require("./User");
exports.FollowBaseSchema = zod_1.z.object({
    user: zod_1.z.instanceof(ObjectId_1.ObjectId),
    follower: zod_1.z.instanceof(ObjectId_1.ObjectId),
});
exports.FollowSchema = exports.FollowBaseSchema.extend(CommonMongoModelFields_1.CommonMongoModelFields);
var FollowDTOSchema = exports.FollowSchema.extend(CommonMongoModelFields_1.CommonModelDTOFields);
exports.FollowDTO = {
    convertFromModel: function (model) {
        var dto = {
            _id: model._id.toString(),
            createdAt: model.createdAt,
            updatedAt: model.updatedAt,
            user: (0, ObjectId_1.isPopulated)(model.user) ? User_1.UserDTO.convertFromModel(model.user) : model.user.toString(),
            follower: (0, ObjectId_1.isPopulated)(model.follower)
                ? User_1.UserDTO.convertFromModel(model.follower)
                : model.follower.toString(),
        };
        return dto;
    },
};
exports.FollowRequestDTOSchema = FollowDTOSchema.extend(__assign(__assign({}, CommonMongoModelFields_1.CommonModelRequestDTOFields), { user: (0, ObjectId_1.ObjectIdString)('Invalid user id'), follower: (0, ObjectId_1.ObjectIdString)('Invalid follower id') }));
//# sourceMappingURL=Follow.js.map